const metrics = [
    {
        name: "work-time",
        value: 7.52,
        oldValue: 5.09,
    },
    {
        name: "work-speed",
        value: 6.23,
        oldValue: 3.78,
    },
    {
        name: "work-process",
        value: 8.23,
        oldValue: 6.31,
    },
];

const overall = {
    value: 7.29,
    oldValue: 6.69,
};

const timeseries = [
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-15 00:00:00",
        value: 8.1,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-16 00:00:00",
        value: 8.1,
    },
    {
        subcategory: "work_process",
        name: "average_commit_size",
        datetime: "2024-04-17 00:00:00",
        value: 8.542,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-11 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-12 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-13 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-14 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-15 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-16 00:00:00",
        value: 5.714,
    },
    {
        subcategory: "work_process",
        name: "backlog_tickets_duration",
        datetime: "2024-04-17 00:00:00",
        value: 5.707,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_given",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "comments_received",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_deployment",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-11 00:00:00",
        value: 9,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-12 00:00:00",
        value: 9,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-13 00:00:00",
        value: 9,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-14 00:00:00",
        value: 9,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-15 00:00:00",
        value: 9.5,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_process",
        name: "commits_per_mr",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-15 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_process",
        name: "directly_to_default",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-15 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-16 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "mr_approvals",
        datetime: "2024-04-17 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "review_pickup_lag",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-11 00:00:00",
        value: 3.8,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-12 00:00:00",
        value: 3.8,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-13 00:00:00",
        value: 3.8,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-14 00:00:00",
        value: 3.775,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-15 00:00:00",
        value: 3.76,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-16 00:00:00",
        value: 4.288,
    },
    {
        subcategory: "work_process",
        name: "stuck_tickets",
        datetime: "2024-04-17 00:00:00",
        value: 4.288,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_process",
        name: "ticket_transition_timings",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-15 00:00:00",
        value: 5.4,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-16 00:00:00",
        value: 8.071,
    },
    {
        subcategory: "work_speed",
        name: "code_per_day",
        datetime: "2024-04-17 00:00:00",
        value: 9.307,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-11 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-12 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-13 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-14 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-15 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-16 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "deployments_per_day",
        datetime: "2024-04-17 00:00:00",
        value: null,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-11 00:00:00",
        value: 7.8,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-12 00:00:00",
        value: 7.7,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-13 00:00:00",
        value: 7.666,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-14 00:00:00",
        value: 7.625,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-15 00:00:00",
        value: 7.68,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-16 00:00:00",
        value: 8.891,
    },
    {
        subcategory: "work_speed",
        name: "in_progress_speed",
        datetime: "2024-04-17 00:00:00",
        value: 8.978,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-11 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-12 00:00:00",
        value: 5,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-13 00:00:00",
        value: 3.333,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-14 00:00:00",
        value: 2.5,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-15 00:00:00",
        value: 4,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-16 00:00:00",
        value: 6,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_per_day",
        datetime: "2024-04-17 00:00:00",
        value: 8,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-15 00:00:00",
        value: 4.05,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-16 00:00:00",
        value: 7.45,
    },
    {
        subcategory: "work_speed",
        name: "pipelines_speed",
        datetime: "2024-04-17 00:00:00",
        value: 7.935,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-11 00:00:00",
        value: 9.6,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-12 00:00:00",
        value: 9.4,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-13 00:00:00",
        value: 9.333,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-14 00:00:00",
        value: 9.3,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-15 00:00:00",
        value: 9.44,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-16 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_speed",
        name: "throughput",
        datetime: "2024-04-17 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-11 00:00:00",
        value: 2.4,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-12 00:00:00",
        value: 2.3,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-13 00:00:00",
        value: 2.266,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-14 00:00:00",
        value: 2.175,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-15 00:00:00",
        value: 2.34,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-16 00:00:00",
        value: 3.051,
    },
    {
        subcategory: "work_speed",
        name: "under_review_speed",
        datetime: "2024-04-17 00:00:00",
        value: 3.332,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-15 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-16 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "code_time",
        datetime: "2024-04-17 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-15 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-16 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "comment_time",
        datetime: "2024-04-17 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-11 00:00:00",
        value: 3,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-12 00:00:00",
        value: 1.5,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-13 00:00:00",
        value: 1,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-14 00:00:00",
        value: 0.75,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-15 00:00:00",
        value: 0.6,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-16 00:00:00",
        value: 1.56,
    },
    {
        subcategory: "work_time",
        name: "deployment_time",
        datetime: "2024-04-17 00:00:00",
        value: 2.16,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-15 00:00:00",
        value: 1.38,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-16 00:00:00",
        value: 1.38,
    },
    {
        subcategory: "work_time",
        name: "mr_opened_time",
        datetime: "2024-04-17 00:00:00",
        value: 2.76,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-11 00:00:00",
        value: 5.7,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-12 00:00:00",
        value: 2.85,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-13 00:00:00",
        value: 1.9,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-14 00:00:00",
        value: 1.425,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-15 00:00:00",
        value: 1.84,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-16 00:00:00",
        value: 3.26,
    },
    {
        subcategory: "work_time",
        name: "pipeline_time",
        datetime: "2024-04-17 00:00:00",
        value: 5.26,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-11 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-12 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-13 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-14 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-15 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-16 00:00:00",
        value: 0,
    },
    {
        subcategory: "work_time",
        name: "ticket_time",
        datetime: "2024-04-17 00:00:00",
        value: 0,
    },
];

const getWorkMiniIndexes = () => {
    return {
        metrics,
        overall,
        timeseries,
    };
};

export default getWorkMiniIndexes;
